// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"82":"5a4151c4","219":"a0bb77fc","320":"65f97ec0","380":"5d2c3e4f"}[chunkId] + ".css";
};